import Vue from 'vue';
import VueTheMask from 'vue-the-mask';
import { VueMaskFilter } from 'v-mask';

/** *
 * Почему две библиотеки масок в проекте
 * Для инпута используется vue-the-mask потому, что во v-mask имеется баг, когда в телефон начинается с трех и более цифр 7, например 77753334455.
 * Для отображения номера используется v-mask filter
 */
Vue.use(VueTheMask);
Vue.filter('VMask', VueMaskFilter);
